export default __webpack_public_path__ + "static/media/deauville01min.68aeb817.jpg";